import { Box, FormControl } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./styles/Survey.css";
import ButtonView from "../common/button/ButtonView";
import TableView from "../common/dataTable/TableView";
import { useDispatch } from "react-redux";
import {
  addItemInVehicleListUpdate,
  addItemInSelectedVehicle,
  deleteItemsFromSelectedPart,
} from "../../store/SurveyPageData";
import {
  CANCEL_LABEL,
  PASTE_LABEL,
  VEHICLE_TO_COPY,
  MARGIN_15,
  CENTER_ITEMS,
} from "../../utils/GlobalConstants";
import {
  getSingleVehicleDetails,
  pastePartsToVehicle,
} from "../../services/SurveyRequest";

const CopyPasteFunctionality = (props) => {
  const [vehicleId, setvehicleId] = useState();
  const [partToCopy, setpartToCopy] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    let listOfParts = [];
    for (const item of props.selected) {
      for (const row of props.rows) {
        if (item === row.id) {
          listOfParts = [...listOfParts, row.source];
          break;
        }
      }
    }
    const finalData =
      listOfParts && listOfParts?.map(({ vehicleId, id, ...rest }) => rest);
    setpartToCopy(finalData);
  }, [props.rows, props.selected]);

  const handleRadio = async (val) => {
    setvehicleId(val);
  };
  const handlePaste = async () => {
    let payload = {
      surveyId: props?.selectedSurveyId,
      vehicleId: vehicleId,
      partDetails: partToCopy,
    };
    props.setIsLoading(true);
    try {
      await pastePartsToVehicle(payload);
      try {
        const response = await getSingleVehicleDetails(vehicleId);
        dispatch(addItemInSelectedVehicle(response?.vehicle));
        dispatch(addItemInVehicleListUpdate([...response?.vehicle?.id]));
        dispatch(deleteItemsFromSelectedPart());
      } catch (e) {
        props.handleClose();
        props.setIsLoading(false);
      }
      props.handleClose();
      props.setSelected([]);

      props.setIsLoading(false);
    } catch (e) {
      props.handleClose();
      props.setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Box>
        <TableView source={VEHICLE_TO_COPY} handleRadio={handleRadio} />
      </Box>
      <Box sx={CENTER_ITEMS}>
        <FormControl>
          <ButtonView
            testid={PASTE_LABEL}
            label={PASTE_LABEL}
            style={MARGIN_15}
            onClick={handlePaste}
            disabled={vehicleId ? false : true}
          ></ButtonView>
        </FormControl>
        <FormControl>
          <ButtonView
            testid={CANCEL_LABEL}
            label={CANCEL_LABEL}
            onClick={props.handleClose}
          ></ButtonView>
        </FormControl>
      </Box>
    </React.Fragment>
  );
};

export default CopyPasteFunctionality;
